// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toggleable-text__text{overflow:hidden;transition:max-height .5s}.toggleable-text__button{display:flex;align-items:center;font-weight:700;font-size:14px;line-height:150%;color:#94b1bf;margin-top:6px;cursor:pointer}.toggleable-text__button svg{margin-right:15px;transition:transform .5s}.toggleable-text__button--hide svg{transform:rotate(180deg)}@media (min-width:768px){.toggleable-text__button{font-size:16px;line-height:150%}}", ""]);
// Exports
module.exports = exports;
